import { hidePageLoad, showPageLoad } from '../../../modules/actions'
import { customAxios as axios, getToken, xTravelAxios } from '../../../request'
import {
  addDirectDepositUrl, addEventXTravelUrl, addMeetingXTravelUrl,
  addXTravelFundTransferRequestUrl,
  approveDirectDepositUrl,
  getAgentMarginActivityUrl,
  getAllDirectDepositUrl, getAllEventsUrl,
  getAllFundTransferRequestUrl, getAllMeetingsUrl, getEventDataByIdUrl, getProfitAndLossUrl,
  singleAgentXTravelMarginUrl,
  singleXTravelExchangeMarginUrl,
  updateFundTransferRequestUrl,
  updateXTravelExchangeMarginUrl,
  updateXTravelMarginUrl
} from '../api'
import { notification } from 'antd'
import { activeAgentsUrl, getAgentWithCreditLimitUrl } from '../../users/api/user'

export const singleAgentXTravelMarginFxn = filters => async dispatch => {
  dispatch(showPageLoad())
  let config = {
    params: { ...filters },
    ...(await getToken())
  }
  let { data } = await axios.get(singleAgentXTravelMarginUrl(), config)
  dispatch(hidePageLoad())
  return data
}

export const updateAgentXTravelMarginFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.put(updateXTravelMarginUrl(), valData, getToken())
  dispatch(hidePageLoad())
  return data
}

export const singleXTravelExchangeMarginFxn = filters => async dispatch => {
  dispatch(showPageLoad())
  let config = {
    params: { ...filters },
    ...(await getToken())
  }
  let { data } = await axios.get(singleXTravelExchangeMarginUrl(), config)
  dispatch(hidePageLoad())
  return data
}

export const updateXTravelExchangeMarginFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.put(updateXTravelExchangeMarginUrl(), valData, getToken())
  dispatch(hidePageLoad())
  return data
}

export const addXTravelTransferRequestFxn = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.post(addXTravelFundTransferRequestUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (!data.error) {
    notification.success({
      message: data.message || 'Success'
    })
  } else {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}

export const getAllFundTransferRequestFxn = filters => async dispatch => {
  dispatch(showPageLoad())
  let config = {
    params: { ...filters },
    ...(await getToken())
  }
  let { data } = await axios.get(getAllFundTransferRequestUrl(), config)
  dispatch(hidePageLoad())

  return data.data
}

export const FundTransferStatusUpdateFxn = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.post(updateFundTransferRequestUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (!data.error) {
    notification.success({
      message: data.message || 'Success'
    })
  } else {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}

export const listAllAgentsMarginActivity = filters => async dispatch => {
  dispatch(showPageLoad())
  let config = {
    params: { ...filters },
    ...(await getToken())
  }
  console.log(config, 'config')
  let { data } = await axios.get(getAgentMarginActivityUrl(), config)
  dispatch(hidePageLoad())
  return data.data
}

export const addDirectDepositFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await xTravelAxios.post(addDirectDepositUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({ message: data.message || 'Error' })
  } else {
    notification.success({ message: data.message || 'Success' })
  }
  return data
}

export const getAllXtravelDirectDepositList = filters => async dispatch => {
  let config = {
    params: { ...filters },
    ...await getToken()
  }
  let { data } = await xTravelAxios.get(getAllDirectDepositUrl(), config)
  return data
}

export const ApproveDirectDepositFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(approveDirectDepositUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (!data.error) {
    notification.success({
      message: data.message || 'Success'
    })
  } else {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}
export const getXTravelProfitAndLossFxn = filters => async dispatch => {
  let config = {
    params: { ...filters },
    ...await getToken()
  }
  let { data } = await xTravelAxios.get(getProfitAndLossUrl(), config)
  return data
}
export const addEventXTravelFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await xTravelAxios.post(addEventXTravelUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({ message: data.message || 'Error' })
  } else {
    notification.success({ message: data.message || 'Success' })
  }
  return data
}
export const getAllEvents = filters => async dispatch => {
  dispatch(showPageLoad())
  let config = {
    params: { ...filters },
    ...await getToken()
  }
  let { data } = await xTravelAxios.get(getAllEventsUrl(), config)
  dispatch(hidePageLoad())
  return data
}
export const getEventDataById = filters => async dispatch => {
  dispatch(showPageLoad())
  let config = {
    params: { ...filters },
    ...await getToken()
  }
  let { data } = await xTravelAxios.get(getEventDataByIdUrl(), config)
  dispatch(hidePageLoad())
  return data
}
export const addMeetingXTravelFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await xTravelAxios.post(addMeetingXTravelUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({ message: data.message || 'Error' })
  } else {
    notification.success({ message: data.message || 'Success' })
  }
  return data
}
export const getAllMeetings = filters => async dispatch => {
  dispatch(showPageLoad())
  let config = {
    params: { ...filters },
    ...await getToken()
  }
  let { data } = await xTravelAxios.get(getAllMeetingsUrl(), config)
  dispatch(hidePageLoad())
  return data
}
